export const SET_USERSADMIN = "SET_USERSADMIN"
export const SET_USERADMIN_LIST_TYPE_DOCUMENT = "SET_USERADMIN_LIST_TYPE_DOCUMENT"
export const SET_USERADMIN_LIST_TYPE_ROL = "SET_USERADMIN_LIST_TYPE_ROL";
export const SET_USER_ADMIN_ID = "SET_USER_ADMIN_ID"
export const SET_USER_ADMIN_COMPANY_ID = "SET_USER_ADMIN_COMPANY_ID";
export const SET_AFFILIATEDUSERS_LIST_GENDER = "SET_AFFILIATEDUSERS_LIST_GENDER";
export const SET_STARASSIGNMENT_SEARCHAFFILIATES = "SET_STARASSIGNMENT_SEARCHAFFILIATES";
export const SET_USERSTATUS = "SET_USERSTATUS";